<template>
    <div>
        <address-create @close="closeCreateAddressCollapse"
                        @new-address-data="newAddressCreated"
                        @default-address-changed="defaultAddressChanged"
                        @error-occurred="showErrorModal()"
                        :php-errors="errors"
                        :countries="countriesArray"
                        :default-country-id="defaultCountryId"
                        :current-type="type"
                        :is-guest="isGuest"
                        :back-link="backLink"
        ></address-create>
    </div>
</template>

<script>
    import AddressCreate from "./AddressCreate";

    export default {
        name: "AddressCreatePage",
        props: {
            errors: {
                type: Array,
                required: false,
                default: []
            },
            'countries': [Object, Array],
            'type': {
                type: String,
                required: false,
                default: 'account'
            },
            defaultCountryId: {
                type: Number,
                required: false,
            },
            backLink: {
                required: false,
                type: String,
            }
        },
        components: { AddressCreate },
        data() {
            return {
                countriesArray: [],
                isGuest: false
            }
        },
        mounted() {

            if (document.getElementById('selected_guest')) {
                document.getElementById('selected_guest').addEventListener('change', (event) => {
                    this.isGuest = event.target.value === 'true'
                });
            }

            for (let countryId in this.countries) {
                this.countriesArray.push(this.countries[countryId]);
            }
        },
        methods: {
            showErrorModal() {
            },
            newAddressCreated() {
            },
            defaultAddressChanged() {
            },
            closeCreateAddressCollapse() {
            },
        }
    }
</script>
